import React, { Component } from "react";
import PropTypes from 'prop-types';
import Waypoint from 'react-waypoint';
import CountUp from 'countup.js';
import Text from 'components/Text';

export default class MoneyCounter extends Component {
  constructor(props) {
    super(...arguments);
    this.state = {
      count: 0,
    };
    this.counter = null;
  }

  componentDidMount() {
    const { price, countOpts } = this.props;
    let counter = this.setCounter(this.Mc, price, countOpts);
    this.counter = counter;
  }


  setCounter = (ref, price, opts) => new CountUp(ref, 0, price, 0, 0.8, opts);

  countMyMoney = () => this.counter.start();

  render() {
    const { price } = this.props;

    return (
      <span>
        <Waypoint onEnter={() => this.countMyMoney()} />
        <Text textRef={r => this.Mc = r} {...this.props}></Text>
      </span>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/MoneyCounter.js